// Generated file - do not change manually!

/**
 * Defines how the text of a component will be displayed when there is not enough space.
 */
export enum WrappingType {
  /**
   * The text will be truncated with an ellipsis.
   */
  None = 'None',

  /**
   * The text will wrap. The words will not be broken based on hyphenation.
   */
  Normal = 'Normal'
}
